import React from "react";
import "./footer.css"; // Importing the CSS file

const Footer = () => {
  return (
    <footer>
      {/* Copyright Section */}
      <div className="footer-info">
        <p>Content is as per the data information of panchayat samiti Jalgaon jamod</p>
        <p>
          Developed and hosted for panchayat samiti, under government guidelines & awaited for audit approval.
        </p>
        <p>Last Updated: <b>Mar 30, 2025</b></p>
      </div>
    </footer>
  );
};

export default Footer;
